const state = {
  pageData: {
    list: [], // 组件列表
    config: {} // 页面配置
  },
  selectWg: {}, // 当前焦点所在组件
  configTab: 'page' // 当前页面配置窗口
}
const mutations = {
  setPageData(state, payload) {
    state.pageData = payload
  },
  setSelectWg(state, payload) {
    state.selectWg = payload
  },
  setConfigTab(state, payload) {
    state.configTab = payload
  }
}

export default {
  state,
  mutations
}
